
import ProductList from "./ProductList";
import NewProduct from "./NewProduct";

export default {
  ProductList,
  NewProduct
}

